import { z } from "zod";
import { apiLegacy } from "../api-legacy";
import { apiWobaBackend } from "../api-woba-backend";

const s3ServiceUploadResponseSchema = z.object({
  uri: z.string(),
  new_uri: z.string(),
});

const s3ServiceUploadAllResponseSchema = z.array(s3ServiceUploadResponseSchema);

export const s3Service = {
  async uploadAllToS3(
    pictures: string[],
    entity: "privaterooms",
  ): Promise<z.infer<typeof s3ServiceUploadAllResponseSchema>> {
    const posts = pictures.map((picture) => {
      return apiLegacy.post(`/v0/services/upload-s3`, {
        uri: picture,
        entity: entity,
      });
    });
    try {
      const results = await Promise.all(posts);

      const mappedData = results.map((result) => {
        return result.data;
      });

      return s3ServiceUploadAllResponseSchema.parse(mappedData);
    } catch (e) {
      console.error(e);
      return [];
    }
  },

  async uploadToS3(picture: string, entity: "privaterooms"): Promise<string> {
    try {
      const result = await apiLegacy.post(`/v0/services/upload-s3`, {
        uri: picture,
        entity: entity,
      });

      const parsed = s3ServiceUploadResponseSchema.parse(result.data);

      const { new_uri } = parsed;

      return new_uri;
    } catch (e) {
      console.error(e);
      return "";
    }
  },
  async uploadAssetToS3(
    file: File,
    assetType: "partner_assignment_term" | "company_assignment_term",
  ): Promise<{ id: string; url: string; name: string }> {
    try {
      const formData = new FormData();

      formData.append("file", file);
      formData.append("type", assetType);

      const result = await apiWobaBackend.post(
        `/private-offices/contracts/assets`,
        formData,
      );

      return {
        id: result.data.contractAsset.id,
        url: result.data.contractAsset.url,
        name: result.data.contractAsset.filename,
      };
    } catch (e) {
      return {
        id: "",
        url: "",
        name: "",
      };
    }
  },
};
